import {Component, OnInit} from '@angular/core';

import EvaluatedFridges from '../../table/configs/evaluatedRefrigerators.json';

@Component({
  selector: 'app-evaluated-refrigerators',
  templateUrl: './evaluated-refrigerators.component.html'
})
export class EvaluatedRefrigeratorsComponent implements OnInit {
  tableConfig;

  constructor() {
  }

  public ngOnInit(): void {
    this.tableConfig = EvaluatedFridges;
  }
}
